import authApi from "../../../contextProviders/auth-api";
import { userActions, apiList, methodType } from "../../../contextProviders/constant";
import { formatDate } from "../AccountSettingsSidebar/accountSettingsSidebarHelper";

export const MODAL_MODE = {
  DISCONNECT: "disconnect",
  CANCEL: "cancel",
  REACTIVATE: "reactivate",
};

export const BILLING_FREQUENCY = {
  MONTHLY: "Monthly",
  YEARLY: "Yearly",
};

export const getPlanLabel = (frequency, translate) => {
  return frequency === BILLING_FREQUENCY.YEARLY
    ? translate("planYearly")
    : translate("planMonthly");
};

export const getConfirmationMessage = (mode, subscription, translate, lang) => {
  const nextBillingDate = subscription?.next_billing_date;
  const hasDate = !!nextBillingDate;
  const formattedDate = hasDate ? formatDate(nextBillingDate, lang) : "";
  const frequency = subscription?.billing_frequency;
  const planLabel = getPlanLabel(frequency, translate);

  switch (mode) {
    case MODAL_MODE.CANCEL: {
      if (!hasDate) return translate("cancelConfirmMessageNoDate");
      return translate("cancelConfirmMessage").replace("{date}", formattedDate);
    }
    case MODAL_MODE.REACTIVATE: {
      return translate("reactivateConfirmMessage").replace("{plan}", planLabel);
    }
    default:
      return "";
  }
};

export const getErrorBodyMessage = (mode, translate) => {
  switch (mode) {
    case MODAL_MODE.DISCONNECT:
      return translate("errorBodyDisconnect");
    case MODAL_MODE.CANCEL:
      return translate("errorBodyCancel");
    case MODAL_MODE.REACTIVATE:
      return translate("errorBodyReactivate");
    default:
      return translate("errorGeneric");
  }
};

export const submitDisconnect = async (partnerAccountId, tokenhandler) => {
  return await authApi({
    url: apiList[userActions.deleteConnection],
    method: methodType.delete,
    body: {
      partner_company_code: "qbo",
      partner_account_id: partnerAccountId,
    },
    tokenhandler,
    isSecured: true,
  });
};

export const submitCancelSubscription = async (tokenhandler) => {
  return await authApi({
    url: apiList[userActions.cancelSubscription],
    method: methodType.post,
    body: {},
    tokenhandler,
    isSecured: true,
  });
};

export const submitReactivate = async (billingFrequency, tokenhandler) => {
  return await authApi({
    url: apiList[userActions.changePlan],
    method: methodType.post,
    body: { billing_frequency: billingFrequency },
    tokenhandler,
    isSecured: true,
  });
};

const helper = {
  MODAL_MODE,
  BILLING_FREQUENCY,
  formatDate,
  getPlanLabel,
  getConfirmationMessage,
  getErrorBodyMessage,
  submitDisconnect,
  submitCancelSubscription,
  submitReactivate,
};

export default helper;
